"use client";
import React, { useState, useEffect, useRef } from "react";

import MatchHistoryItem from "./MatchHistoryItem";
import MatchHistoryHeader from "./MatchHistoryHeader";
import "./../recent.scss"
const MatchHistoryTable = ({ matches, isHalftimeChecked }) => {
  const tableContainerRef = useRef(null);
  const fakeScrollRef = useRef(null);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [fakeScrollWidth, setFakeScrollWidth] = useState(0);
  const [fakeScrollPosition, setFakeScrollPosition] = useState(0);
  const [isShowScroll, setIsShowScroll] = useState(false);

  useEffect(() => {
    if (tableContainerRef.current) {
      if (tableContainerRef.current.scrollWidth > tableContainerRef.current.clientWidth) {
        setIsShowScroll(true)
      }
    }
    if (tableContainerRef.current && fakeScrollRef.current) {
      const container = tableContainerRef.current;
      const fakeScroll = fakeScrollRef.current;

      // Tính tỷ lệ cuộn
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;

      if (scrollWidth > clientWidth) {
        setIsShowScroll(true)
      }


      //Tỉ lệ cục scroll so với full w-element 
      const scrollThumbWidth = (clientWidth / scrollWidth) * clientWidth;


      //Phần trăm scroll giả
      const scrollLeftFake = scrollLeft / scrollWidth * fakeScroll.scrollWidth

      // Tính chiều rộng thanh cuộn giả
      setFakeScrollWidth(scrollThumbWidth); // Lưu lại chiều rộng của thanh cuộn giả

      // Cập nhật vị trí của thanh cuộn giả
      const fakeScrollPosition = (scrollLeftFake)

      setFakeScrollPosition(fakeScrollPosition);
    }
  }, [scrollLeft, isShowScroll]);

  const syncScroll = () => {
    if (tableContainerRef.current) {
      setScrollLeft(tableContainerRef.current.scrollLeft);
    }
  };
  return (
    <div className="relative">
      <div ref={tableContainerRef}
        onScroll={syncScroll}
        className={"w-full overflow-x-scroll overflow-y-hidden max-lg:[&>*]:w-[816px] scrollable"}
        style={{
          overflowX: "scroll",
          scrollbarWidth: "none", /* For Firefox */
          msOverflowStyle: "none", /* For Internet Explorer */
        }}
      >
        <MatchHistoryHeader />

        <div
          className={
            "flex flex-col justify-center items-center gap-1 w-full mt-1"
          }
        >
          {matches.map((match, index) => (
            <MatchHistoryItem key={index} match={match} isHalftimeChecked={isHalftimeChecked} />
          ))}
        </div>
        <style>
          {`
      div::-webkit-scrollbar {
        display: none; /* For WebKit */
      }
    `}
        </style>
      </div>
      {/* Fake horizontal scrollbar */}
      {isShowScroll ? <div
        ref={fakeScrollRef}
        className="bg-[#FFFFFF] h-1.5 mt-1 rounded-[5px]"
        style={{
          position: "absolute",
          bottom: "-15px",
          left: "50%",
          width: "90%", 
          backgroundColor: "#d1d5db",
          overflow: "hidden",
          transform: "translate(-50%, -50%)"
        }}
      >
        <div
          className="bg-[#D9D9D9] h-1.5 rounded-[5px]"
          style={{
            width: `${fakeScrollWidth}px`, 
            transform: `translateX(${fakeScrollPosition * 0.9}px)`,
          }}
        ></div>
      </div> : null}

    </div>

  );
};

export default MatchHistoryTable;
